import script from "./ContactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=e4b62248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4b62248"]])

export default __exports__